import { AfterViewInit, Component, Inject } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeviceDetectorService } from 'ngx-device-detector';
import { InAppNotification } from '../../../services/pcode/notification/notification.models';
import { NotificationService } from '../../../services/pcode/notification/notification.service';
import { NotificationDetailsDialogInput } from './notification-details-dialog.models';

@Component({
    selector: 'pcode-notification-details-dialog',
    templateUrl: './notification-details-dialog.component.html',
    styleUrls: ['./notification-details-dialog.component.scss'],
    standalone: false
})
export class NotificationDetailsDialogComponent implements AfterViewInit
{
	_currentNotification: InAppNotification;
	_isMobile = false;

	// constructor
	constructor
		(
			private dialogRef: MatDialogRef<NotificationDetailsDialogComponent>,
			@Inject(MAT_DIALOG_DATA) private model: NotificationDetailsDialogInput,
			private fb: UntypedFormBuilder,
			private notificationService: NotificationService,
			private deviceService: DeviceDetectorService
		)
	{
	}

	// after view init
	ngAfterViewInit()
	{
		this._isMobile = this.deviceService.isMobile();

		this.notificationService.getNotification(this.model.id).subscribe(result =>
		{
			this._currentNotification = result;
			this._currentNotification.type = this.model.type;

			// check: if incoming, set as read
			if (this.model.setAsRead)
				this.readNotification(this.model.id);
		});
	}

	// follow link
	followLink(link: string)
	{
		this.dialogRef.close({ action: "follow-link", link: link });
	}

	// read notification
	readNotification(id: string)
	{
		this.notificationService.setNotificationAsRead(id).subscribe();
	}

	// close dialog
	closeDialog()
	{
		this.dialogRef.close({ created: false });
	}
}
